package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminRequestAssessmentPayload(
    @SerialName("coachID")
    val coachId: String,
    @SerialName("adminID")
    val adminId: String,
    val coachName: String,
    val adminEmail: String,
    val adminName: String,
    val organization: String,
    val requestType: String,
    val eventDateTime: String,
    val seasonID: String
)
